import { BookingI } from './booking';
import { ClubI } from './club';
import { EventProductServiceI, ProductI } from './products';
import { RegionsI } from './region';
import { ServicesI } from './services';

// Temporary type definition to avoid Prisma client dependency during development
export enum TestEventStatusType {
  SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN_PROGRESS',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  CLOSED = 'CLOSED',
  NOT_SCHEDULED = 'NOT_SCHEDULED',
}

// Frontend-safe mirror of the Prisma `ReservationStatusType` enum (string values
// match the DB so runtime comparisons / API payloads are identical). Kept here so
// frontend domain code never imports `@prisma/client` (backend) — see CLAUDE.md.
export enum ReservationStatusType {
  NEW = 'NEW',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
}

export enum EVENT_STATUS {
  OK,
  CANCELLED,
  PLANNED,
  VERIFIED,
  CONFIRMED,
}

// export enum RegionterritoryI{
//   ABX,
//   BodyAnalytics,
//   EmployeeOwned,
//   Shared
// }

export interface EventStatusDataI {
  id: string;
  status: EVENT_STATUS;
}

export interface UpdateTestingEventI {
  testEventDate?: string;
  startTime?: string;
  endTime?: string;
  signupInterval?: string;
  // BUG-A1 tri-state assignment on EDIT: undefined/omitted = no change,
  // explicit null = unassign (clear the nullable FK), string = assign.
  assignedTruckId?: string | null;
  isAllowedSignupOnline?: boolean;
  isPaymentRequired?: boolean;
  isTestingEventPrivate?: boolean;
  testEventDescription?: string;
  assignedOperatorId?: string | null;
  testEventName?: string;
  status?: string; // Use string instead of Prisma enum to avoid compilation issues
  productId?: string[]; // Array of product IDs for updating event products
  testEventAtClubId?: string; // Club ID for updating event location
  // Private-event fields (#1125) — only sent when isTestingEventPrivate is true.
  // accessCode is normalized + validated (8-char [A-Z0-9]) server-side on write.
  accessCode?: string;
  hostName?: string;
  hostByline?: string;
}
export interface EventPrimaryDataI {
  body: string;
  earnings: number;
  // club_testingevent_id: string;
  testEventName: string;
  createdAt: string;
  // creator_id: string;
  testEventDescription: string;
  imageUrl: string;
  // end_time: null;
  // event_date: string;
  startTime: string;
  endTime: string;
  testEventDate: string;
  id: string;
  testEventCustomerSignupsId: string;
  slotIntreval: string;
  slug: string;
  // start_time: string;
  status: string;
  // testingevent_creator_id: string;
  // testingevent_id: string;
  title: string;
  updatedAt: string;
  testEventAtClub: ClubI;
  assignedTruckId: string;
  assignedOperatorId: string;
  isAllowedSignupOnline: boolean;
  isPaymentRequired: boolean;
  isTestingEventPrivate: boolean;
  assignedOperator: string;
  assignedTruck: string;
  assignedClub: string;
  testEventAtClubId: string;
  signupInterval: string;

  // slotTime: string | null | undefined;
  // id: string;
  // testEventName: string;
  // testEventDate: string;
  // startTime: string;
  // endTime: string;
  // status: TestingEventStatusEnum.DRAFT;
  // assignedOperator?: string;
  // signupInterval?: string;
  // isAllowedSignupOnline?: boolean;
  // isPaymentRequired?: boolean;
  // isTestingEventPrivate?: boolean;
  // testEventDescription?: string;
  // testEventAtClub: ClubI;
  // testEventAtClubId?: string;
  // clubId?: string;
  // testEventSlots: SlotI[];
  // location:{
  //   latitude: number,
  //   longitude: number
  // }
  // "testEventName": "ClubNienow - MillerEvent",
  // "testEventDescription": "Fitness Challenge 19",
  // "testEventDate": "Fri Jan 05 2024",
  // "startTime": "2023-12-18T22:25:38-06:00",
  // "endTime": "2023-12-20T09:47:24-06:00",
}
// "testEventName": "ClubNienow - MillerEvent",
// "testEventDescription": "Fitness Challenge 19",
// "testEventDate": "Fri Jan 05 2024",
// "startTime": "2023-12-18T22:25:38-06:00",
// "endTime": "2023-12-20T09:47:24-06:00",
// "status": "OK",
// "signupInterval": "TEN_MIN",
// "isAllowedSignupOnline": true,
// "isPaymentRequired": true,
// "isTestingEventPrivate": false,
// "testEventAtClubId": null,
// "assignedOperatorId": null,
// "assignedTruckId": null,
// "testEventNoteId": null,
// "testEventForNutritionChallengeId": null,
// "testEventForCheckInId": null,
// "testEventWithDiscountId": null,
// "createdAt": "2023-12-19T21:57:35.995Z",
// "updatedAt": "2023-12-19T21:57:35.995Z",
// "region_id": null,
// "testEventCustomerSignupsId": null,
// "regionId": null,
// "signupId": null,
// "signupSlug": null,
// "testEventAtClub": null,
// "availableServices": [],
// "availableSlots": []

export interface CreateTestEventI {
  id?: string;
  testEventDate: string;
  startTime: string;
  endTime: string;
  isAllowedSignupOnline: boolean;
  isPaymentRequired: boolean;
  isTestingEventPrivate: boolean;
  // Private-event fields (#1120) — only meaningful when isTestingEventPrivate is true.
  accessCode?: string | null;
  hostName?: string | null;
  hostByline?: string | null;
  assignedOperator: string;
  assignedTruck: string;
  assignedClub: string;
  signupInterval: string;
  createdEvent?: TestingEventI;
  // slots?:SlotI
}
export interface TestingEventRequiredProps {
  testEventName: string;
  createdAt: string;
  // creator_id: string;
  testEventDescription: string;
  // end_time: null;
  // event_date: string;
  startTime: string;
  endTime: string;
  testEventDate: string;
  id: string;
  testEventCustomerSignupsId: string;
  slotIntreval: string;
  slug: string;
  // start_time: string;
  status: string;

  title: string;
  updatedAt: string;
  testEventAtClub: ClubI;
  assignedTruckId: string;
  assignedOperatorId: string;
  isAllowedSignupOnline: boolean;
  isPaymentRequired: boolean;
  isTestingEventPrivate: boolean;
  assignedOperator: string;
  assignedTruck: string;
  assignedClub: string;
  testEventAtClubId: string;
  signupInterval: string;
}
export interface PromoCodeI {
  // id: string;
  // object: string;
  // #2150: the promo-validate API serializes these from Prisma Decimals, so the
  // wire delivers STRINGS (e.g. "100") even though they are conceptually numbers.
  // Type them honestly as `string | number | null` and run every read through
  // `coercePromoAmount()` at the boundary instead of hand-rolling `Number()` casts
  // at each consumer (which is how the 3 divergent workarounds arose).
  percent_off: null | number | string;
  discountAmount: null | number | string;
  discountCode: string;
  isCustomerDiscount: boolean;
  isPackage: boolean;
  maxRedeemption: number;
  // active: boolean;
  // code: string;
  // coupon: {
  //   id: string;
  //   object: string;
  //   amount_off: null | number;
  //   created: string;
  //   currency: null;
  //   duration: string;
  //   duration_in_months: number;
  //   livemode: boolean;
  //   max_redemptions: null;
  //   metadata: {};
  //   name: string;
  //   percent_off: number;
  //   redeem_by: null;
  //   times_redeemed: number;
  //   valid: boolean;
  // };

  // expires_at: string;
  // livemode: boolean;
  // max_redemptions: null;

  // restrictions: {
  //   first_time_transaction: boolean;
  //   minimum_amount: number;
  //   minimum_amount_currency: string;
  // };
  // times_redeemed: number;
}

/**
 * #2150: single boundary coercion for the `PromoCodeI` money fields
 * (`percent_off`, `discountAmount`). The promo-validate API serializes these
 * from Prisma `Decimal`, so they arrive as STRINGS on the wire even though the
 * app treats them as numbers. Consumers must call this once when reading the
 * value instead of scattering `Number()` casts (see the 3 divergent workarounds
 * described in #2150).
 *
 * Returns `null` for `null`/`undefined`/empty/non-finite input so callers can
 * distinguish "no promo value" from a real `0`, and never propagate `NaN`.
 */
export function coercePromoAmount(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export interface OrderConfirmationI {
  id: string;
  orderNumber: string;
  orderSummaryId?: string;
  selectService?: string;
  subtotal?: number;
  quantity?: number;
  serviceFee?: number;
  total?: number;
  orderDate: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  gymName?: string;
  eventDate?: string;
  selectedSlotTime?: string;
  address?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  orderDetails: OrderDetailsI[];
  ordersForTestingEvent: TestingEventI;
  booking: BookingI;
  // "lastName": "Parisian",
  // "emailAddress": "Parisian",
  // "address": "4583 Monahan Cape",
  // "country": "USA",
  // "city": "New Malvina",
  // "zipCode": "37688-3864",
  // "required_date": "2023-12-14T00:00:00.000Z",
  // // "employee_id": null,
  // "shipped_date": "2024-11-27T00:00:00.000Z",
  // "ship_via": null,
  // "freight": null,
  // "customerId": null,
  // "createdAt": "2023-12-13T20:34:37.975Z",
  // "updatedAt": "2023-12-13T20:34:37.975Z",
  // "bodyFatMeasureTestProductId": null,
  // "paymentId": null,
  // "operatorId": null,
  // "linksId": null,
  // "testingEventId": null,
  // "mealPlanId": null,
  // "trainerId": null
}

// export interface BookingI {}
export interface OrderDetailsI {
  productId: string;
  price: number;
  quantity: number;
  salesTax: number;
  serviceFee: number;
  subTotal: number;
  totalAmount: number;
  products: ProductI;
  productsPurchased: EventProductsI;
}

export interface EventProductsI {
  id: string;
  stripeProductId: string;
  stripeProductName: string;
  description?: string;
  orderCount?: number; // Number of orders associated with this product
}

export interface TestEventSearchI {
  preset: string[];
  searchTerm: string;
}

/**
 * Minimal region projection returned alongside an event list row — just the
 * fields the redesigned admin events list renders (#1148). Kept separate from
 * the full `RegionsI` so the tenant-scoped list query can `select` only what it
 * needs rather than hydrating the whole relation.
 */
export interface EventListRegionI {
  id: string;
  regionName: string | null;
}

/**
 * Tenant-scoped events-list row (#1148). Carries the redesign columns the admin
 * events table needs per row: capacity (`maxCapacity`), a derived `bookedCount`
 * (count of CONFIRMED bookings), the event's `region`, and `revenue` (sum of
 * PAID payments for the event, in dollars; 0 when none). The frontend derives
 * OPEN (`bookedCount < maxCapacity`) / FULL (`bookedCount >= maxCapacity`).
 *
 * Deliberately a dedicated interface rather than widening `TestingEventI`, whose
 * other consumers assume their fields are always present.
 */
export interface EventListRowI {
  id: string;
  testEventName: string;
  testEventDescription: string;
  testEventDate: string;
  startTime: string;
  endTime: string;
  status: string;
  maxCapacity: number;
  bookedCount: number;
  region: EventListRegionI | null;
  /** Sum of PAID `Payment.amount` (dollars) for this event's bookings; 0 when none. */
  revenue: number;
}
export interface RegionLocationI {
  id: number;
  name: string;
  city: string;
  state: string;
  photo: string;
  availableUnits: number;
  // wifi: boolean;
  // laundry: boolean;
}
export interface TestingEventI {
  body: string;
  earnings: number;
  // club_testingevent_id: string;
  testEventName: string;
  // Hours before testEventDate after which a cancellation no longer earns account
  // credit (Prisma TestingEvent.cancelCutoffHours, default 24). Optional on the
  // FE model because legacy/unhydrated reads may omit it; the cancel-policy note
  // (#836) falls back to 24h when absent.
  cancelCutoffHours?: number;
  createdAt: string;
  // creator_id: string;
  testEventDescription: string;
  imageUrl: string;
  // end_time: null;
  // event_date: string;
  startTime: string;
  endTime: string;
  testEventDate: string;
  id: string;
  testEventCustomerSignupsId: string;
  slotIntreval: string;
  slotIntrevalValue: number;
  slug: string;
  // start_time: string;
  status: string;
  // testingevent_creator_id: string;
  // testingevent_id: string;
  title: string;
  updatedAt: string;
  testEventAtClub: ClubI;
  assignedTruckId: string;
  assignedOperatorId: string;
  isAllowedSignupOnline: boolean;
  isPaymentRequired: boolean;
  isTestingEventPrivate: boolean;
  // Private-event fields (#1120) — only meaningful when isTestingEventPrivate is true.
  // accessCode is admin-only; it is never returned by public/unauthenticated reads (#1122).
  accessCode?: string | null;
  hostName?: string | null;
  hostByline?: string | null;
  assignedOperator: string;
  assignedTruck: string;
  assignedClub: string;
  testEventAtClubId: string;
  signupInterval: string;
  // Maximum number of bookings the event accepts (Prisma TestingEvent.maxCapacity,
  // default 10). Returned by the admin detail read (`manage-events-api/details/:id`)
  // and consumed by the event-detail capacity card (#1154). Optional on the FE model
  // because legacy/unhydrated reads may omit it; the capacity card falls back to 0.
  maxCapacity?: number;
  eventProducts: EventProductServiceI[];
  region: RegionsI;
  userId: string; // createdByUser
  // services: ServicesI[];
  // products: ProductI[];
  // slotTime: string | null | undefined;
  // id: string;
  // testEventName: string;
  // testEventDate: string;
  // startTime: string;
  // endTime: string;
  // status: TestingEventStatusEnum.DRAFT;
  // assignedOperator?: string;
  // signupInterval?: string;
  // isAllowedSignupOnline?: boolean;
  // isPaymentRequired?: boolean;
  // isTestingEventPrivate?: boolean;
  // testEventDescription?: string;
  // testEventAtClub: ClubI;
  // testEventAtClubId?: string;
  // clubId?: string;
  // testEventSlots: SlotI[];
  // location:{
  //   latitude: number,
  //   longitude: number
  // }
  availableSlots: SlotI[];
  availableProducts: ProductI[];
  availableServices: ServicesI[];
  reservation: ReservationI;
}
export interface SelectedServiceI {
  serviceId: number;
  // slot: string; // Reference to the chosen time slot, could be more complex
  // You can include additional properties like serviceName, price, etc., for ease of display
  serviceName: string;
  price: number;
  selectedSlot: TimeSlotI;
  // provider: string; // Name of the provider chosen by the customer
  additionalRequests: string; // Any additional requests or preferences

  // Other properties like provider name, special requests, etc.
}
export interface ProviderAvailabilityI {
  dayOfWeek: number; // 0 (Sunday) to 6 (Saturday)
  startTime: string; // Start time of availability in HH:MM format
  endTime: string; // End time of availability in HH:MM format
}

export interface ContactInfoI {
  email: string;
  phone: string;
  address: string; // Could be the address of the salon/spa/clinic
}
export interface ProviderI {
  id: number;
  name: string;
  bio: string; // A brief biography or introduction of the provider
  imageUrl: string; // URL for the provider's profile picture
  rating: number; // Average rating based on customer feedback
  specialties: number[]; // Array of service IDs that the provider specializes in
  availability: ProviderAvailabilityI[]; // Provider's availability schedule
  contactInfo: ContactInfoI; // Contact information for the provider
  languages: string[]; // Languages spoken by the provider
  yearsOfExperience: number; // Years of experience in their field
}

export interface CategoryI {
  name: string;
  id: string;
  description?: string; // Optional description of the category
  imageUrl?: string; // Optional image URL for the category
  // Additional properties like description, icon, etc., can be included
  featuredServices: number[]; // IDs of featured services for quick access
}

export interface TimeSlotI {
  id: string; // Unique identifier for the time slot
  startTime: Date; // Start time of the slot
  slotDate?: Date; // Date time of the slot
  slotTime?: Date; // Time of the slot
  slotStartTime?: Date; // Start time of the slot
  slotEndTime?: Date; // End time of the slot
  isSelected?: boolean; // Indicates if the slot is available for booking
  endTime: Date; // End time of the slot
  isAvailable: boolean; // Indicates if the slot is available for booking
  // maxBookings: number; // Maximum number of concurrent bookings allowed for this slot
  maxCapacity: number; // Maximum number of bookings allowed in this slot
  currentBookings: number; // Current number of bookings in this slot
  // Additional properties as needed
  providersAvailable: ProviderI[];
  // time: string; // Could be a string like '9:00 AM - 10:00 AM' or a more complex structure
  // // Additional properties like slotId, availability, etc., can be added
}

export enum TestingEventStatusEnum {
  DRAFT = 'Draft',
  PLANNED = 'Planned',
  CREATED = 'Created',
  SCHEDULLED = 'Scheduled',
  CANCELLED = 'Cancelled',
}

export interface SlotNI {
  slotTime: Date | string;
  startTime: string;
  endTime: Date | string;
  isAvailable: boolean;
  isSelected: boolean;
}
export interface SlotI {
  id: string;
  isAvailable: boolean;
  isSelected: boolean;
  slotDate?: string;

  startTime: Date | string;
  slotEndTime?: string;
  slotStartTime?: string;
  slotTime?: string;
  testingEventId?: string;
  slotsSignupScheduledTimesId?: string;
  name?: string;
  num?: number;
}

export interface ReservationI {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  contactTimeOption: string;
  contactTitle: string;
  clubName: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  companyWebsite: string;
  eventType: string;
  testEventDate: string;
  startTime: string;
  endTime: string;
  isAllowedSignupOnline: boolean;
  isPaymentRequired: boolean;
  isTestingEventPrivate: boolean;
  isRemindByEmail: boolean;
  isConsentFlag: boolean;
  status: string;
  testEventId: string;
  createdAt: string;
  // #1721: admin-assignable region -- set via the Edit dialog before confirming,
  // so the resulting TestingEvent is discoverable by region search.
  regionId?: string;
}

// "id": "29a968f4-d29c-4a05-8e09-0fb175d7e4c8",
// "slotDate": "2023-12-09T14:30:00.000Z",
// "slotStartTime": "2023-12-09T14:30:00.000Z",
// "slotEndTime": "2023-12-09T14:45:00.000Z",
// "slotTime": "2023-12-09T14:30:00.000Z",
// "isAvailable": true,
// "slotsForTestingEventId": "0097d2f1-26a3-4d87-95b0-ce51d549d50d",
// "signupAvailabilityId": "d62eb9d9-e978-47f2-962f-3907ae672e4a",
// "signupAvailabilityTestingEventId": "0097d2f1-26a3-4d87-95b0-ce51d549d50d"
